import React from 'react'
import { Flex } from 'front-end/src/components'

import { FlexProps } from '@chakra-ui/react'
import classNames from 'classnames'
type sizeEnum = 'sm' | 'md' | 'lg' | 'xl'
export type IconSVGProps = FlexProps & {
  size?: sizeEnum
}

const getSize = (size: sizeEnum) => {
  switch (size) {
    case 'sm':
      return '12px'
    case 'md':
      return '18px'
    case 'lg':
      return '22px'
    case 'xl':
      return '32px'
    default:
      return '18px'
  }
}
export default function IconSVG(props: IconSVGProps) {
  const { className, size, ...rest } = props
  const cssClasses = classNames('icon Icon', className)

  return (
    <Flex
      as="span"
      display="inline-flex"
      align="center"
      justify="center"
      boxSize={getSize(size || 'md')}
      role="img"
      aria-label={props.className?.replace(/([A-Z])/g, ' $1').trim()} // Add space between next word (camel case)
      {...rest}
      className={cssClasses}
    />
  )
}
